export default {
  blogsView: {
    title: 'Blogs',
  },
  blogView: {
    label: {
      relatedArticles: 'related articles',
    },
  },
  blogCarousel: {
    cta: {
      readMore: 'Read more',
      allProviders: 'All Producer blogs',
    },
  },
  filters: {
    label: {
      selectedFilters: 'Filters',
      all: 'All',
      headers: {
        typeOfBlog: 'Content type',
        themes: 'Themes',
        authors: 'Authors',
      },
    },
    button: {
      cancel: 'Cancel',
      filter: 'Filter',
    },
    noRecordsFound: 'No records found',
  },
};
